"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageToAll = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveMessage_gameSync_sidecar_1 = require("./diveMessage_gameSync-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.Dive_SimulationFrame;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.gameSyncNumber);
    messageWriter_sidecar_1.messageWriter.write32(m, d.frame);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_crew);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_bullets);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_objects);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_spells);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crc_misc);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        gameSyncNumber: messageWriter_sidecar_1.messageWriter.read16(m),
        frame: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_crew: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_bullets: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_objects: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_spells: messageWriter_sidecar_1.messageWriter.read32(m),
        crc_misc: messageWriter_sidecar_1.messageWriter.read32(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        gameSyncNumber: 1549,
        frame: 12046,
        crc_crew: 524202158,
        crc_bullets: 5467789,
        crc_objects: 4236789,
        crc_spells: 25867234,
        crc_misc: 4586789,
    };
    messageWriter_sidecar_1.messageWriter.test('simulationFrame', ex, write, read);
}
exports.test = test;
function process(m, isFromHost, fromId) {
    // console.log('process simulation frame')
    var msg = read(m);
    var frame = msg.frame;
    // console.log('set simulation frame', frame, isFromHost)
    // TODO: make sure this is from the host? Doesn't seem to work with self-sent messages
    //if (isFromHost) {
    if (msg.gameSyncNumber !== websockets_sidecar_1.websockets.getGameSyncNumber()) {
        console.log('game sync number mismatch, updating');
        websockets_sidecar_1.websockets.setGameSyncNumber(msg.gameSyncNumber);
        diveSimulationManager_sidecar_1.diveSimulationManager.get().gameSyncNumber = msg.gameSyncNumber;
        // Clear our frames
        // TODO: need a pause / unpause message to reset stuff or something
        // diveSimulationManager.get().currentSimuationFrame = 0
        // diveSimulationManager.get().simulateToFrame = 0
        // diveSimulationManager.get().nextFrameCrc = 0
        // diveSimulationManager.get().nextFrameCrcFrame = 0
        // Acknolwedge game sync number to the host
        diveMessage_gameSync_sidecar_1.diveMessage_gameSync.sendMessageToHost({
            gameSyncNumber: websockets_sidecar_1.websockets.getGameSyncNumber(),
        });
    }
    diveSimulationManager_sidecar_1.diveSimulationManager.addCrcCheckToBuffer(msg);
    diveSimulationManager_sidecar_1.diveSimulationManager.get().frameTimeAccumulator_waitingForNextFrame = false;
    diveSimulationManager_sidecar_1.diveSimulationManager.get().simulateToFrame = frame;
    // websockets.setSimulationFrame(frame)
    //}
    // Add to crc check
    // console.log('add crc check')
    // TODO: need to sync crc checks?
    // let cur = voyageMultiplayerCursors.findByMultiIdSafe(fromId)
    // if (cur) {
    //   voyageMultiplayerCursors.networkRecieveStartLerpToXY(cur, msg.x, msg.y)
    // }
}
exports.process = process;
function sendMessageToAll(msg) {
    websockets_sidecar_1.websockets._sendMessageToAll(write, msg, true);
}
exports.sendMessageToAll = sendMessageToAll;
